import * as React from "react";
import { observer } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  PaperProps,
} from "@mui/material";
import Draggable1 from "react-draggable";
import { useRootStore } from "../../../store/contexts";
const Draggable: any = Draggable1;

type GridExpressProps = {
  title: string;
  description: string;
  open: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  confirmLabel?: string;
  hideCancelButton?: boolean;
  // Ok deshabilitado (p. ej., mientras se consulta si se puede borrar).
  confirmDisabled?: boolean;
  // Cancelar deshabilitado (p. ej., mientras se borra).
  cancelDisabled?: boolean;
  children?: React.ReactNode;
};

export const ConfirmCancelDialog: React.FC<GridExpressProps> = observer(
  ({
    title,
    description,
    open,
    onConfirm,
    onCancel,
    onClose,
    confirmLabel,
    hideCancelButton,
    confirmDisabled,
    cancelDisabled,
    children,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const PaperComponent = (props: PaperProps) => {
      const nodeRef = React.useRef(null);
      return (
        <Draggable
          nodeRef={nodeRef}
          handle="#draggable-dialog-title"
          cancel={'[class*="MuiDialogContent-root"]'}
        >
          <Paper ref={nodeRef} {...props} />
        </Draggable>
      );
    };

    return (
      <Dialog
        open={open}
        onClose={onClose ? onClose : onCancel}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        sx={{ zIndex: 10400 }}
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ whiteSpace: "pre-line" }}>
            {description}
          </DialogContentText>
          {children}
        </DialogContent>
        <DialogActions>
          {!hideCancelButton && onCancel && (
            <Button autoFocus onClick={onCancel} disabled={cancelDisabled}>
              {langStore.cancelCommand}
            </Button>
          )}
          <Button onClick={onConfirm} disabled={confirmDisabled}>
            {confirmLabel || "Ok"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);
